import { useSidebar } from "@/components/ui/sidebar";
import { SidebarItemType } from "@/constants/constant";
import RCollapseSidebarItem from "@/components/RComponents/SidebarComponents/RCollapseSidebarItem";
import RCollapseSidebarMenu from "@/components/RComponents/SidebarComponents/RCollapseSidebarMenu";
import RIconSidebarMenu from "@/components/RComponents/SidebarComponents/RIconSidebarMenu";
import RIconSideBarMenuItem from "@/components/RComponents/SidebarComponents/RIconSideBarMenuItem";
import RNormalSidebarItem from "@/components/RComponents/SidebarComponents/RNormalSidebarItem";
import RNormalSidebarMenu from "@/components/RComponents/SidebarComponents/RNormalSidebarMenu";
import RSidebarGroup from "@/components/RComponents/SidebarComponents/RSidebarGroup";
import RSubMenuSidebar from "@/components/RComponents/SidebarComponents/RSubMenuSidebar";
import RSubMenuSidebarItem from "@/components/RComponents/SidebarComponents/RSubMenuSidebarItem";
import { AllSidebarItemTypes } from "@/types/index.type";
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

export const renderSidebarItem = (item: AllSidebarItemTypes) => {
  const { open: isSidebarOpened, openMobile: isSidebarMobileOpened } =
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSidebar();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { permissions: userPermissions } = useSelector((state: RootState) => state.auth);
  const hasSuperAdminPermission = userPermissions.includes("ROLE_SUPER_ADMIN");

  // Helper function to check permissions
  const hasRequiredPermissions = (requiredPermissions?: string | string[]) => {
    if (!requiredPermissions) return true;
    if (hasSuperAdminPermission) return true;
    const permissions = Array.isArray(requiredPermissions)
      ? requiredPermissions
      : [requiredPermissions];
    return permissions.some(permission =>
      userPermissions.includes(permission)
    );
  };

  // Filter items based on permissions
  const filterItemsByPermissions = (items: any[]): any[] => {
    return items.filter(item => {
      // Check if item has required permissions
      if ('requiredPermissions' in item) {
        return hasRequiredPermissions(item.requiredPermissions);
      }

      // Handle nested items based on their type
      if ('items' in item) {
        const filteredItems = filterItemsByPermissions(item?.items);
        // Update the items array with filtered results
        item.items = filteredItems;
        // Keep the parent item only if it has visible children
        return filteredItems.length > 0;
      }

      return true;
    });
  };

  // Filter items before rendering
  if ('items' in item) {
    item.items = filterItemsByPermissions(item?.items as any[]);
    if (item.items.length === 0) return null;
  }

  if (!isSidebarOpened && !isSidebarMobileOpened) {
    switch (item.type) {
      case SidebarItemType.COLLAPSE_ITEM:
      case SidebarItemType.NORMAL_ITEM:
      case SidebarItemType.ICON_ITEM:
        return <RIconSideBarMenuItem key={item.title} {...item} />;
    }
  }
  switch (item.type) {
    case SidebarItemType.GROUP:
      return <RSidebarGroup key={item.title} {...item} />;
    case SidebarItemType.COLLAPSE_MENU:
      return <RCollapseSidebarMenu key={item.title} {...item} />;
    case SidebarItemType.NORMAL_MENU:
      return <RNormalSidebarMenu key={item.title} {...item} />;
    case SidebarItemType.ICON_MENU:
      return <RIconSidebarMenu key={item.title} {...item} />;
    case SidebarItemType.COLLAPSE_ITEM:
      return <RCollapseSidebarItem key={item.title} {...item} />;
    case SidebarItemType.NORMAL_ITEM:
      return <RNormalSidebarItem key={item.title} {...item} />;
    case SidebarItemType.ICON_ITEM:
      return <RIconSideBarMenuItem key={item.title} {...item} />;
    case SidebarItemType.SUB_MENU:
      return <RSubMenuSidebar key={item.title} {...item} />;
    case SidebarItemType.SUB_ITEM:
      return <RSubMenuSidebarItem key={item.title} {...item} />;
    default:
      "wrong type";
  }
};
